import { useNavigate } from "react-router-dom";
import { MapPin } from "lucide-react";

import { Badge } from "@/components/kit";
import { C } from "@/lib/format";

export const APPT_TYPES = [
  { key: "rdv_client", label: "RDV client" }, { key: "visite_chantier", label: "Visite chantier" },
  { key: "reunion", label: "Réunion" }, { key: "appel", label: "Appel" }, { key: "autre", label: "Autre" },
];
export const typeLabel = (k) => APPT_TYPES.find((t) => t.key === k)?.label ?? k;
export const typeColor = (k) =>
  k === "visite_chantier" ? C.success : k === "reunion" ? C.silver : k === "appel" ? C.warning : k === "autre" ? C.muted : C.brand;

const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const hm = (iso) => iso.slice(11, 16).replace(":", "h");
export const dayLabel = (s) => new Date(`${s}T12:00`).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });

export function AppointmentItem({ a, showDate, hideDossier }) {
  const navigate = useNavigate();
  const multi = a.end.slice(0, 10) !== a.start.slice(0, 10);
  return (
    <button
      type="button"
      data-testid={`appointment-item-${a.id}`}
      onClick={() => navigate(`/admin/appointment-form?id=${a.id}`)}
      className="pressable flex w-full gap-3 rounded-[20px] border border-l-4 border-[#333333] bg-[#1E1E1E] p-4 text-left"
      style={{ borderLeftColor: typeColor(a.type) }}
    >
      <span className="w-16 shrink-0">
        <span className="t-h3 block">{hm(a.start)}</span>
        <span className="t-caption block">{hm(a.end)}</span>
      </span>
      <span className="flex min-w-0 flex-1 flex-col gap-1">
        {showDate || multi ? (
          <span className="t-caption !text-[#D4AF37] first-letter:uppercase">
            {multi ? `Du ${dayLabel(a.start.slice(0, 10))} au ${dayLabel(a.end.slice(0, 10))}` : dayLabel(a.start.slice(0, 10))}
          </span>
        ) : null}
        <span className="t-h3 line-clamp-2">{a.title}</span>
        <Badge label={typeLabel(a.type)} color={typeColor(a.type)} />
        {a.location ? (
          <span className="flex items-center gap-1">
            <MapPin className="h-3.5 w-3.5 shrink-0 text-[#9E9E9E]" aria-hidden />
            <span className="t-caption truncate">{a.location}</span>
          </span>
        ) : null}
        {a.dossier && !hideDossier ? <span className="t-caption truncate">Dossier {a.dossier.number} · {a.dossier.client_name}</span> : null}
        <span className="t-caption truncate">{a.participants.map((p) => p.name).join(", ")}</span>
      </span>
    </button>
  );
}
